export const reduxKey = '@@ADS';
export const actionKey = '@@ADS';
// The minimum time between ads refresh on page url change
export const adsRefreshTimeout = 10000;
// The max number of times ads can refresh per session
export const maxAdsRefresh = 60;
// cachebuster for any botd changes, also need to update lib.ads php file to match
export const mightBeBotVersion = '2';
